/* Geurvinder matching extras, added to window.GeurvinderEngine:
   - "lijkt op" search: direct lookalikes (custom.lijkt_op), a reference perfume list for anything else, and
     products that share its notes and family
   - note hints on result cards
   - gift-set suggestions */
(function (root, factory) {
  var node = typeof module === 'object' && module.exports;
  var E = node ? require('./engine.js') : root.GeurvinderEngine;
  if (E) factory(E);
  if (node) module.exports = E;
})(typeof self !== 'undefined' ? self : this, function (E) {
  'use strict';
  var I = E._internal, flat = I.flat, words = I.words, list = I.list, STOP = I.STOP, GROUPS = E.GROUPS;

  function sig(s) { return flat(s).split(' ').filter(function (t) { return t.length >= 3 && !STOP[t]; }); }

  function lev(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length;
    if (Math.abs(m - n) > 2) return 3;
    var prev = [], cur;
    for (var j = 0; j <= n; j++) prev[j] = j;
    for (var i = 1; i <= m; i++) {
      cur = [i];
      for (var k = 1; k <= n; k++) {
        cur[k] = Math.min(prev[k] + 1, cur[k - 1] + 1, prev[k - 1] + (a[i - 1] === b[k - 1] ? 0 : 1));
      }
      prev = cur;
    }
    return prev[n];
  }
  function tokenHit(token, hay) {
    for (var i = 0; i < hay.length; i++) {
      var h = hay[i];
      if (h === token) return true;
      if (token.length >= 5 && h.length >= 5 && lev(token, h) <= (token.length >= 8 ? 2 : 1)) return true;
    }
    return false;
  }

  // Query against custom.lijkt_op. 1 = same perfume, 0.85 = a flanker of it, 0.5 = some words in common.
  // strict (a reference perfume was recognised): the brand is already in its keys, so a lijkt_op that is only
  // one word of the name ("Blue" for "Bleu de Chanel") no longer counts as the same perfume.
  function likeScore(P, q, strict) {
    var l = P.likeN;
    if (!q || !l) return 0;
    if (l === q) return 1;
    if (!strict && l.length >= 4 && (' ' + q + ' ').indexOf(' ' + l + ' ') >= 0) return 0.95;
    var qt = sig(q), lt = l.split(' ');
    if (!qt.length) return 0;
    var hit = 0;
    qt.forEach(function (t) { if (tokenHit(t, lt)) hit++; });
    if (hit === qt.length) return sig(l).length > qt.length ? 0.85 : 0.9;
    return hit ? 0.5 : 0;
  }

  // ---------- notes ----------
  var SYN = {
    frankincense: 'wierook', olibanum: 'wierook', incense: 'wierook', tonka: 'tonkaboon', 'tonka boon': 'tonkaboon',
    cacao: 'chocolade', munt: 'pepermunt', vanillestokje: 'vanille', vanilla: 'vanille', patchouli: 'patchoeli',
    suede: 'leer', leather: 'leer', kasjmier: 'cashmeran', aquatische: 'aquatisch', zeezout: 'zout', cipres: 'cypress',
    ceder: 'cederhout', oudh: 'oud', sandalwood: 'sandelhout'
  };
  var GENERIC = /^(houtachtige|kruidige|bloemige|fruitige|zoete|groene|citrus|gourmand|aromatische|poederige|rokerige|droge|orientaalse|droge houtnoten|witte bloemen|witte houtsoorten|rood fruit|rode vruchten|edelhout)$/;
  function normNote(s) {
    var k = flat(s).replace(/ noten$/, '');
    return SYN[k] || k;
  }
  function notesOf(P) {
    if (P._notes) return P._notes;
    var seen = {};
    // i = position in the product's note list, used to show the same note from the translated product data
    P._notes = list(P.raw.n).map(function (s, i) { return { k: normNote(s), d: String(s).trim().toLowerCase(), i: i }; })
      .filter(function (x) { if (!x.k || GENERIC.test(x.k) || seen[x.k]) return false; seen[x.k] = 1; return true; });
    return P._notes;
  }
  function noteHit(r, k) {
    if (r === k) return true;
    if ((' ' + k + ' ').indexOf(' ' + r + ' ') >= 0) return true;
    return r.length >= 4 && k.length >= 4 && (' ' + r + ' ').indexOf(' ' + k + ' ') >= 0;
  }

  // ---------- reference perfumes ----------
  var parsed = [], parsedFrom = null, NOTEW = {};
  E.GROUP_ORDER.forEach(function (g) { GROUPS[g].kw.forEach(function (k) { NOTEW[normNote(k)] = 1; }); });
  function parseRef(lines) {
    if (!lines || !lines.length) return [];
    if (parsedFrom === lines) return parsed;
    parsedFrom = lines;
    parsed = lines.map(function (line) {
      var f = String(line).split('|');
      var R = {
        n: f[0], b: f[1] || '', bk: flat(f[1]), g: f[2] || 'U', f: (f[3] || '').split(' ').filter(Boolean),
        k: (f[4] || '').split(',').map(normNote).filter(function (x, i, a) { return x && a.indexOf(x) === i; }),
        keys: [f[0]].concat(f[5] ? f[5].split(',') : []).map(flat).filter(Boolean)
      };
      R.k.forEach(function (k) { NOTEW[k] = 1; });
      return R;
    });
    return parsed;
  }
  function resolveRef(q, refs) {
    var best = null, bs = 0, qw = ' ' + q + ' ';
    var single = sig(q);
    var noteWord = single.length === 1 && !!NOTEW[normNote(single[0])];
    refs.forEach(function (R) {
      var bt = R.bk.split(' ');
      var qt = single.filter(function (t) { return bt.indexOf(t) < 0; });
      R.keys.forEach(function (k) {
        var s = 0;
        if (q === k || q === R.bk + ' ' + k) s = 1;
        else if (noteWord) s = 0;
        else if (k.length >= 3 && qw.indexOf(' ' + k + ' ') >= 0) s = 0.85 + Math.min(k.length, 30) / 300;
        else if (qt.length) {
          var kt = sig(k);
          if (kt.join('').length >= 4 && kt.every(function (t) { return tokenHit(t, qt); })) s = 0.8;
          else if (!noteWord && qt.join('').length >= 4 && qt.every(function (t) { return tokenHit(t, kt); })) s = 0.72;
        }
        if (s > bs) { bs = s; best = R; }
      });
    });
    return bs >= 0.7 ? best : null;
  }
  function genderFit(R, P) {
    if (R.g === 'M' && P.gender === 'F') return 0.4;
    if (R.g === 'F' && P.gender === 'M') return 0.4;
    return 1;
  }
  // 0..1: notes shared with the reference perfume plus overlap in scent family
  function noteSim(R, P) {
    var pk = notesOf(P), shared = 0;
    R.k.forEach(function (r) { if (pk.some(function (x) { return noteHit(r, x.k); })) shared++; });
    var gsum = 0;
    R.f.forEach(function (g) { gsum += P.gm[g] || 0; });
    var gfit = R.f.length ? 0.7 * gsum / R.f.length + 0.3 * (R.f.indexOf(P.primary) >= 0 ? 1 : 0) : 0;
    if (!pk.length) return 0.45 * gfit;
    var ns = Math.min(1, shared / Math.sqrt(R.k.length * Math.max(pk.length, 3)));
    return 0.65 * ns + 0.35 * gfit;
  }

  // Builds the matcher used by E.rank (opts.matcher). refLines = window.GeurvinderRef (may be missing).
  E.makeMatcher = function (query, refLines) {
    var q = flat(query);
    if (q.length < 2) return null;
    var R = resolveRef(q, parseRef(refLines));
    var nk = normNote(q);
    var note = !R && NOTEW[nk] ? nk : '';
    var keys = [q].concat(R ? R.keys.concat(R.keys.map(function (k) { return R.bk + ' ' + k; })) : []);
    return {
      q: q, R: R, note: note, want: R && R.g === 'M' ? 'him' : R && R.g === 'F' ? 'her' : '',
      score: function (P) {
        var self = P.selfN || (P.selfN = flat(P.name));
        if (self.length >= 3 && (q === self || q === flat(P.vendor) + ' ' + self)) return { s: 1, d: 1 };
        var d = 0;
        for (var i = 0; i < keys.length; i++) d = Math.max(d, likeScore(P, keys[i], !!R));
        if (note) {
          var n0 = notesOf(P).some(function (x) { return noteHit(nk, x.k); }) ? 0.8 : P.titleW.indexOf(' ' + nk + ' ') >= 0 ? 0.7 : 0;
          return d >= 0.5 || n0 ? { s: Math.max(d, n0), d: d } : null;
        }
        if (!R) return d >= 0.5 ? { s: d, d: d } : null;
        var gf = genderFit(R, P);
        if (d < 1) d *= gf;
        if (d < 0.8) d = 0;
        var n = noteSim(R, P) * gf;
        return d || n >= 0.3 ? { s: Math.max(d, 0.8 * n), d: d } : null;
      }
    };
  };

  // Adds r.notes (2-3 notes to show on the card, Dutch), r.noteIdx (their positions in the product's note list)
  // and r.notesSame (true when they are the notes shared with the reference perfume).
  E.annotate = function (results, A, M) {
    var fams = A.mode === 'like' ? [] : (A.fams || []);
    results.forEach(function (r) {
      var pn = notesOf(r.P), pick = [];
      r.notesSame = false;
      if (M && M.R) {
        M.R.k.forEach(function (rk) {
          var x = pn.filter(function (y) { return noteHit(rk, y.k); })[0];
          if (x && pick.indexOf(x) < 0) pick.push(x);
        });
        if (pick.length >= 2) r.notesSame = true;
        else pick = [];
      }
      if (!pick.length) {
        var hit = [], rest = [];
        pn.forEach(function (x) {
          var w = ' ' + x.k + ' ';
          var on = (M && M.note && noteHit(M.note, x.k)) || fams.some(function (g) {
            return GROUPS[g].kw.some(function (kw) { return w.indexOf(' ' + kw + ' ') >= 0; });
          });
          (on ? hit : rest).push(x);
        });
        pick = hit.concat(rest);
      }
      pick = pick.slice(0, 3);
      r.notes = pick.map(function (x) { return x.d; });
      r.noteIdx = pick.map(function (x) { return x.i; });
    });
    return results;
  };

  // ---------- gift sets ----------
  var NOT_GIFT = / (geurblok|opruiming|luchtverfrisser|deodorant)/;
  // Strips " – Cadeauset" and its translations from a set title.
  var SET_SUFFIX = /\s+[-–—]\s+(parfumset|cadeauset|cadeaupakket|geschenkset|geschenkpaket|parfümset|duftset|gift ?set|gift box|perfume set|coffret|set de regalo|estuche|pack de regalo)(?![\wÀ-ɏ]).*$/i;
  E.setName = function (title, vendor) {
    var t = E.displayTitle(title, vendor);
    return t.replace(SET_SUFFIX, '').trim() || t;
  };
  E.prepareSets = function (raws) {
    var n = raws.length;
    return raws.map(function (raw, i) {
      var P = I.prepare(raw, i, n);
      P.gender = I.genderOf(raw, P.tagsW, P.titleW + words(raw.u));
      P.name = E.setName(P.title, P.vendor) || P.title;
      return P;
    }).filter(function (P) { return P.price > 0 && !NOT_GIFT.test(P.titleW); });
  };
  E.rankSets = function (sets, A, results, opts) {
    opts = opts || {};
    var L = Number(opts.budgetLow) || 15, H = Number(opts.budgetHigh) || 30;
    var tops = (results || []).slice(0, 6), out = [];
    (sets || []).forEach(function (S) {
      var gs = I.genderScore(S, A.gender);
      if (gs < 0) return;
      var b = I.budgetScore(S, A.budget, L, H), link = 0, why = null;
      tops.forEach(function (r) {
        // the set contains a recommended perfume; names made of note words ("Oud", "Red") are too generic
        var t = sig(r.P.name);
        if (link || t.join('').length < 5 || t.every(function (x) { return NOTEW[x]; })) return;
        if (t.every(function (x) { return S.titleW.indexOf(' ' + x + ' ') >= 0; })) { link = 1; why = r; }
      });
      if (!link && tops.some(function (r) { return flat(r.P.vendor) === flat(S.vendor); })) link = 0.3;
      // the gift version of a recommended perfume may go up to 50% over the budget
      var tier = b[1] && !(link === 1 && S.price / 100 <= (A.budget === 'low' ? L : H) * 1.5) ? 1 : 0;
      out.push({ P: S, tier: tier, why: why, score: 30 * gs + 22 * b[0] + 30 * link + 8 * I.famScore(S, A.fams) + 10 * S.pop });
    });
    out.sort(function (a, b) { return a.tier - b.tier || b.score - a.score; });
    var seen = {}, res = [];
    out.forEach(function (o) { if (res.length < (opts.setMax || 3) && !seen[o.P.key]) { seen[o.P.key] = 1; res.push(o); } });
    return res;
  };

  I.likeScore = likeScore;
  I.resolveRef = function (q, lines) { return resolveRef(flat(q), parseRef(lines)); };
  I.noteSim = noteSim;
  I.normNote = normNote;
});